import {FC, useState, useEffect, Fragment} from 'react'

import './style.css'

import './style.css'
import {PageTitle} from '_metronic/layout/core'
import {useNavigate} from 'react-router-dom'

type Props = {
  handleToPage: any
}

const NotRegisteredPageContent: FC<Props> = ({handleToPage}) => {
  const navigate = useNavigate()

  const handleRegister = () => {
    handleToPage('register')
  }

  return (
    <div className='col-md-12'>
      <p className='h5'>Status Pendaftaran</p>
      <div className='card mt-5 d-flex justify-content-center'>
        <div className='d-flex justify-content-center mt-15'>
          <img
            src={require('../../assets/img/register.png')}
            alt='PANA'
            className='img-fluid'
            style={{height: 'auto', width: '20%'}}
          />
        </div>

        <div className='d-flex justify-content-center'>
          <div className='col-md-7 text-center'>
            <p className='h6 mt-10'>Saatnya Beraksi untuk Indonesia!</p>
            <p>
              Belum ada pendaftaran untuk program pengabdian di daerah tertinggal? Jangan lewatkan
              kesempatan emas untuk memberikan dampak nyata bagi masyarakat. Daftar sekarang dan
              jadilah bagian dari solusi!
            </p>
          </div>
        </div>

        <div className='d-flex justify-content-center p-5 mb-5'>
          <button
            className='btn btn-primary btn-sm rounded-pill'
            style={{backgroundColor: '#F95E2F'}}
            onClick={() => handleRegister()}
          >
            Daftar Sekarang!
          </button>
        </div>
      </div>
    </div>
  )
}

const NotRegisteredPage: FC<Props> = ({handleToPage}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'PANA',
            path: '/pana-beranda',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        My Application PANA
      </PageTitle>
      <NotRegisteredPageContent handleToPage={handleToPage}/>
    </>
  )
}

export default NotRegisteredPage
